import { createSelector } from 'reselect';

const selectGlobalSettings = (state: any) => state.globalSettings;


export const selectGlobalSettingsCurrentItem = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.current);

export const selectGlobalSettingsListItems = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.list);

export const selectGlobalSettingsItemById = (itemId: any) =>
    createSelector(selectGlobalSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalSettingsQueryItems = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.query);

export const selectGlobalSettingsCreatedItem = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.create);

export const selectGlobalSettingsUpdatedItem = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.update);

export const selectGlobalSettingsReadItem = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.read);

export const selectGlobalSettingsDeletedItem = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.delete);

export const selectGlobalSettingsSearchedItems = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.search);

export const selectGlobalSettingsItemsCount = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.count);

export const selectGlobalSettingsItemsFilter = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.filter);

export const selectGlobalSettingsSummaryItems = createSelector([selectGlobalSettings], (globalSettings) => globalSettings.summary);